import { IngredientTypeName } from "../data/ingredientModel";
import { createDiv, createElem } from "../util";
import { Ingredient } from "../data/ingredientModel";
import { game } from "../gameManager";

export class Item {
    div: HTMLElement;

    constructor(public ingredient: Ingredient) {}

    createElement(parent: HTMLElement) {
        // I think base ingredients and recipe ingredients will look different,
        // but for now this is copy paste.
        this.div = createDiv(parent, "ingredient");

        const info = createDiv(this.div, "info");

        const iconContainer = createDiv(info, "icon-container");
        const icon = createElem("img", iconContainer, "icon") as HTMLImageElement;
        icon.src = `assets/ingredients/${this.ingredient.icon}.png`;
        
        const infoContainer = createDiv(info, "info-container");
        createElem("h4", infoContainer, "", this.ingredient.name);

        const props = createDiv(infoContainer, "props");
        createElem("h3", props, "", IngredientTypeName[this.ingredient.type]);

        const cost = createDiv(props, "cost");
        cost.innerHTML = `<span class="money">${this.ingredient.cost.toString()}</span><span class="coin"></span>`;

        const symbolsDiv = createDiv(info, "symbols");
        for (let i=0; i<3; i++){
            var symbol = this.ingredient.symbols[i];
            createDiv(symbolsDiv, "symbol symbol-"+symbol);
        }

        this.div.onclick = () => this.addToRecipe();
    }

    addToRecipe() {
        game.addIngredient(this);
    }
}